import { forwardRef } from "react";
import { Link, type LinkProps } from "@/lib/router-compat";
import { prefetchRoute, prefetchByPath } from "@/lib/routePrefetch";

type Props = LinkProps & {
  /** Override explícito da chave de prefetch. Por padrão, infere de `to`. */
  prefetch?: "marcaDetalhe" | "marcas" | "causaDetalhe" | "causas" | null;
};

/**
 * Drop-in para <Link> que pré-carrega o chunk lazy da rota destino
 * ao primeiro hover, focus ou touchstart — barato e idempotente.
 */
export const PrefetchLink = forwardRef<HTMLAnchorElement, Props>(
  ({ prefetch, to, onMouseEnter, onFocus, onTouchStart, ...rest }, ref) => {
    const key = prefetch === undefined ? prefetchByPath(to) : prefetch;

    const warm = () => {
      if (key) prefetchRoute(key);
    };

    return (
      <Link
        ref={ref}
        to={to}
        onMouseEnter={(e) => {
          warm();
          onMouseEnter?.(e);
        }}
        onFocus={(e) => {
          warm();
          onFocus?.(e);
        }}
        onTouchStart={(e) => {
          warm();
          onTouchStart?.(e);
        }}
        {...rest}
      />
    );
  }
);

PrefetchLink.displayName = "PrefetchLink";